import React from 'react';
import { AnchorTitle } from './styles';
const website_url = 'www.servicetitan.com';

export const linkTarget = url => (url.match(website_url) ? '_self' : '_blank');
export const linkRel = url => (url.match(website_url) ? '' : 'noopener noreferrer');

const HyperLink = ({ color, children, href, target, rel, ...otherProps }) => {
  href = href || '';

  return href.startsWith('#') ? (
    <AnchorTitle id={href.substring(1, href.length)} style={{ color }} {...otherProps}>
      {children}
    </AnchorTitle>
  ) : href.startsWith('title=') ? (
    <AnchorTitle id={href.substring(6, href.length)} style={{ color }} {...otherProps}>
      {children}
    </AnchorTitle>
  ) : href.startsWith('to=') ? (
    <a href={href.split('=')[1]} style={{ color }} {...otherProps}>
      {children}
    </a>
  ) : (
    <a
      href={href}
      style={{ color }}
      target={target || linkTarget(href)}
      rel={rel || linkRel(href)}
      {...otherProps}
    >
      {children}
    </a>
  );
};

export default HyperLink;
